import { PopUpType } from "@/domain/enums/pop-up-type";

export const optInVariations: Partial<Record<PopUpType, string>> = {
	[PopUpType.OPT_INT_POP_UP]: 'control',
	[PopUpType.EXPERIMENT_A_OPT_IN_POP_UP]: 'variation1',
	[PopUpType.EXPERIMENT_C_OPT_IN_POP_UP]: 'variation2',
};
